import { II18n } from '../../../../../models';
import { I18nService } from '../../../../../services';
import React from 'react';

const translations: II18n = {
  es: {
    relationalGroup: 'Seleccionar grupo de contexto',
  },
  enUS: {
    relationalGroup: 'Select context group',
  },
  ptBR: {
    relationalGroup: 'Selecione o grupo de contexto',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
